import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Cookie } from "lucide-react";

const TXT = {
    nl: { text: "Cookies toestaan voor anonieme statistieken?", policy: "Cookiebeleid", accept: "Accepteren", decline: "Weigeren" },
    fr: { text: "Autoriser les cookies pour des statistiques anonymes ?", policy: "Politique de cookies", accept: "Accepter", decline: "Refuser" },
    en: { text: "Allow cookies for anonymous statistics?", policy: "Cookie policy", accept: "Accept", decline: "Decline" },
    es: { text: "¿Permitir cookies para estadísticas anónimas?", policy: "Política de cookies", accept: "Aceptar", decline: "Rechazar" },
};

export const CONSENT_KEY = "vsf_cookie_consent";

export default function CookieBanner() {
    const { i18n } = useTranslation();
    const [visible, setVisible] = useState(() => {
        try { return !localStorage.getItem(CONSENT_KEY); } catch { return false; }
    });
    if (!visible) return null;
    const lang = (i18n.language || "nl").slice(0, 2);
    const t = TXT[lang] || TXT.nl;

    const choose = (value) => {
        try { localStorage.setItem(CONSENT_KEY, value); } catch {}
        if (value === "accepted") {
            window.__loadPostHog?.();
            window.__loadOaiq?.();
        }
        setVisible(false);
    };

    return (
        <div className="fixed bottom-0 inset-x-0 z-[90] p-3 sm:p-4" data-testid="cookie-banner">
            <div className="max-w-xl mx-auto bg-[#0F0F11] border border-white/10 rounded-md shadow-2xl p-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                <Cookie className="h-5 w-5 text-[#E5A93D] shrink-0 hidden sm:block" />
                <p className="text-xs sm:text-sm text-zinc-300 flex-1">
                    {t.text}{" "}
                    <Link to="/cookies" className="text-[#E5A93D] hover:underline" data-testid="cookie-banner-policy-link">{t.policy}</Link>
                </p>
                <div className="flex items-center gap-2 shrink-0">
                    <button
                        type="button"
                        onClick={() => choose("declined")}
                        className="h-10 px-4 text-sm text-zinc-400 hover:text-white border border-white/10 rounded-sm transition"
                        data-testid="cookie-decline-btn"
                    >
                        {t.decline}
                    </button>
                    <button
                        type="button"
                        onClick={() => choose("accepted")}
                        className="h-10 px-5 text-sm font-bold bg-[#E5A93D] hover:bg-[#FBBF24] text-black rounded-sm transition active:scale-95"
                        data-testid="cookie-accept-btn"
                    >
                        {t.accept}
                    </button>
                </div>
            </div>
        </div>
    );
}
